module.exports = __webpack_public_path__ + "img/belarus.4506d74f.svg";